module.exports = __webpack_public_path__ + "static/media/AwesomeProfileCardsReact_cover.d4def0da.png";